import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { getSetting } from "../../Services/Setting";
import PageHeader from "../../Components/PageHeader";
import "../Dashboard/Dashboard.css";

const SECTION_THEMES = {
    route: { icon: "fa-route", theme: "primary" },
    search: { icon: "fa-satellite-dish", theme: "secondary" },
    weight: { icon: "fa-weight-hanging", theme: "info" },
    fees: { icon: "fa-hands-helping", theme: "warning" },
    penalty: { icon: "fa-hand-holding-usd", theme: "danger" },
    promo: { icon: "fa-gift", theme: "success" },
    firstDelivery: { icon: "fa-truck-loading", theme: "primary" },
    insurance: { icon: "fa-shield-alt", theme: "success" },
    payout: { icon: "fa-calendar-alt", theme: "primary" },
    support: { icon: "fa-headset", theme: "info" },
};

export default function Settings() {
    const { isLoading, data: settingData } = useQuery("get-setting", getSetting);
    const settings = settingData?.data?.data;

    if (isLoading && !settings) {
        return (
            <div className="settings-page-loading">
                <div className="spinner-border text-primary" role="status" />
            </div>
        );
    }

    const renderDetail = (label, value, unit = "", suffix = "", icon = "fa-circle-notch", colClass = "col-sm-6 col-xl-3") => {
        const displayValue = value !== undefined && value !== null && value !== "" ? value : "---";

        return (
            <div className={colClass}>
                <div className="settings-stat-card">
                    <div className="settings-stat-card__icon">
                        <i className={`fas ${icon}`} />
                    </div>
                    <span className="settings-stat-card__label">{label}</span>
                    <div className="settings-stat-card__value-row">
                        {unit ? <span className="settings-stat-card__unit">{unit}</span> : null}
                        <span className="settings-stat-card__value">{displayValue}</span>
                        {suffix ? <span className="settings-stat-card__suffix">{suffix}</span> : null}
                    </div>
                </div>
            </div>
        );
    };

    const renderSection = (title, subtitle, themeKey, children) => {
        const theme = SECTION_THEMES[themeKey];

        return (
            <div className="col-12">
                <div className="settings-section-card">
                    <div className="settings-section-card__header">
                        <div className={`settings-section-card__icon settings-section-card__icon--${theme.theme}`}>
                            <i className={`fas ${theme.icon}`} />
                        </div>
                        <div>
                            <h5 className="settings-section-card__title">{title}</h5>
                            {subtitle ? <p className="settings-section-card__subtitle">{subtitle}</p> : null}
                        </div>
                    </div>
                    <div className="row g-3">{children}</div>
                </div>
            </div>
        );
    };

    return (
        <div className="app-content content dashboard">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="pricing-logistics">
                        <div className="user-details-wrapper settings-page">
                            <PageHeader
                                title="System Settings"
                                subtitle="Manage global app configurations, pricing rates, and platform policies"
                                action={
                                    <Link to="/settings/edit" className="siteBtn settings-page__edit-btn">
                                        <i className="fas fa-edit me-2" />
                                        Update Rates
                                    </Link>
                                }
                            />

                            <div className="row g-4">
                                {renderSection(
                                    "Distance & Trip Charges",
                                    "Mileage and platform commission (base fee is set per vehicle type)",
                                    "route",
                                    <>
                                        {/* Base pickup fee removed — base fare is included in Vehicle Type Management prices */}
                                        {renderDetail("Free Miles Included", settings?.freeDistanceMiles, "", "miles", "fa-road")}
                                        {renderDetail("Price per Extra Mile", settings?.pricePerMile, "$", "/mi", "fa-tachometer-alt")}
                                        {renderDetail("Muvrrs Platform Fee", settings?.adminCommission, "", "%", "fa-percentage")}
                                    </>
                                )}

                                {renderSection(
                                    "Search & Matching Configuration",
                                    "Driver discovery radius and notification limits",
                                    "search",
                                    <>
                                        {renderDetail("Driver Search Radius", settings?.radiusDistance, "", settings?.radiusUnit, "fa-crosshairs", "col-sm-6 col-xl-4")}
                                        {renderDetail("Search Timeout", settings?.timeoutTime, "", settings?.timeoutUnit, "fa-clock", "col-sm-6 col-xl-4")}
                                        {renderDetail("Max Drivers Notified", settings?.maxDriverNotifications, "", "drivers", "fa-users", "col-sm-6 col-xl-4")}
                                    </>
                                )}

                                {renderSection(
                                    "Weight Based Surcharges",
                                    "Extra charges for heavier packages",
                                    "weight",
                                    <>
                                        {renderDetail("Standard Weight Limit", settings?.baseWeightLbs, "", "lbs", "fa-balance-scale", "col-sm-6 col-xl-4")}
                                        {renderDetail("Weight Step Unit", settings?.addWeightPlusLbs, "", "lbs", "fa-plus-circle", "col-sm-6 col-xl-4")}
                                        {renderDetail("Price per Weight Step", settings?.stepPrice, "$", "", "fa-dollar-sign", "col-sm-6 col-xl-4")}
                                    </>
                                )}

                                {renderSection(
                                    "Extra Item & Labor Fees",
                                    "Optional add-ons for fragile items and helpers",
                                    "fees",
                                    <>
                                        {renderDetail("Fragile Item Fee", settings?.fragileItemFee, "$", "/item", "fa-wine-glass-alt", "col-sm-6")}
                                        {renderDetail("Helper Assistance Fee", settings?.extraHelperFee, "$", "/helper", "fa-user-friends", "col-sm-6")}
                                    </>
                                )}

                                {/* <div className="col-12">
                                    <div className="settings-section-card">
                                        <div className="settings-section-card__header">
                                            <div className="settings-section-card__icon settings-section-card__icon--danger">
                                                <i className="fas fa-hand-holding-usd" />
                                            </div>
                                            <div>
                                                <h5 className="settings-section-card__title">Post-Acceptance Penalty Settings</h5>
                                                <p className="settings-section-card__subtitle">
                                                    Cancellation charges after a driver accepts the ride
                                                </p>
                                            </div>
                                        </div>

                                        <div className="settings-penalty-box">
                                            <div>
                                                <h6 className="settings-penalty-box__title">Cancellation Penalty Rate</h6>
                                                <p className="settings-penalty-box__text mb-0">
                                                    Charge on total fare after driver acceptance
                                                </p>
                                            </div>
                                            <span className="settings-penalty-box__value">
                                                {settings?.afterAcceptanceCancellationFeePercent || 0}%
                                            </span>
                                        </div>

                                        <div className="settings-penalty-note">
                                            <i className="fas fa-shield-alt" />
                                            <p className="mb-0">
                                                Automatic protection enabled:
                                                <strong> {settings?.afterAcceptanceCancellationFeePercent || 0}%</strong> penalty applies to any cancellation made after a driver accepts the request.
                                            </p>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-12">
                                    <div className="settings-section-card">
                                        <div className="settings-section-card__header settings-section-card__header--split">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="settings-section-card__icon settings-section-card__icon--primary">
                                                    <i className="fas fa-truck-loading" />
                                                </div>
                                                <div>
                                                    <h5 className="settings-section-card__title">First Delivery Offer Settings</h5>
                                                    <p className="settings-section-card__subtitle mb-0">
                                                        First booking free or percentage off for new users
                                                    </p>
                                                </div>
                                            </div>
                                            <span className={`settings-status-badge ${settings?.firstDeliveryOfferStatus ? "is-enabled" : "is-disabled"}`}>
                                                {settings?.firstDeliveryOfferStatus ? "Enabled" : "Disabled"}
                                            </span>
                                        </div>
                                        <div className="row g-3">
                                            {renderDetail(
                                                "Offer Type",
                                                settings?.firstDeliveryOfferType === "free"
                                                    ? "First Delivery Free"
                                                    : settings?.firstDeliveryOfferType === "percentage"
                                                      ? "Percentage Discount"
                                                      : "---",
                                                "",
                                                "",
                                                "fa-tags",
                                                "col-sm-6 col-xl-4"
                                            )}
                                            {settings?.firstDeliveryOfferType === "free" ? (
                                                renderDetail("Offer Value", "FREE", "", "", "fa-gift", "col-sm-6 col-xl-4")
                                            ) : (
                                                renderDetail(
                                                    "Discount Percentage",
                                                    settings?.firstDeliveryOfferDiscountPercent,
                                                    "",
                                                    "%",
                                                    "fa-percentage",
                                                    "col-sm-6 col-xl-4"
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="settings-section-card">
                                        <div className="settings-section-card__header settings-section-card__header--split">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="settings-section-card__icon settings-section-card__icon--success">
                                                    <i className="fas fa-star" />
                                                </div>
                                                <div>
                                                    <h5 className="settings-section-card__title">Review Offer Settings</h5>
                                                    <p className="settings-section-card__subtitle mb-0">
                                                        Discount earned after rating a completed delivery
                                                     </p>
                                                </div>
                                            </div>
                                            <span className={`settings-status-badge ${settings?.isreviewDiscountEnabled ? "is-enabled" : "is-disabled"}`}>
                                                {settings?.isreviewDiscountEnabled ? "Enabled" : "Disabled"}
                                            </span>
                                        </div>
                                        <div className="row g-3">
                                            {renderDetail(
                                                "Review Discount Offer",
                                                settings?.reviewDiscountOffer,
                                                settings?.reviewDiscountOfferType === "percentage" ? "" : "$",
                                                settings?.reviewDiscountOfferType === "percentage" ? "%" : "",
                                                settings?.reviewDiscountOfferType === "percentage" ? "fa-percentage" : "fa-dollar-sign",
                                                "col-sm-6"
                                            )}
                                            {renderDetail("Applied on Booking #", settings?.bookingNumber, "", "", "fa-sort-numeric-up", "col-sm-6")}
                                        </div>
                                    </div>
                                </div>

                                {renderSection(
                                    "Support Contact",
                                    "Shown on Help & Support in the user and driver apps",
                                    "support",
                                    <>
                                        {renderDetail("Support Email", settings?.supportEmail, "", "", "fa-envelope", "col-sm-6")}
                                        {renderDetail("Support Phone", settings?.supportPhone, "", "", "fa-phone-alt", "col-sm-6")}
                                    </>
                                )}

                                {renderSection(
                                    "Insurance Configuration",
                                    "Optional insurance pricing for bookings",
                                    "insurance",
                                    <>
                                        <div className="col-sm-6 col-xl-3">
                                            <div className="settings-stat-card">
                                                <div className="settings-stat-card__icon">
                                                    <i className="fas fa-toggle-on" />
                                                </div>
                                                <span className="settings-stat-card__label">Insurance Status</span>
                                                <span className={`settings-status-badge mt-2 ${settings?.insuranceStatus ? "is-enabled" : "is-disabled"}`}>
                                                    {settings?.insuranceStatus ? "Enabled" : "Disabled"}
                                                </span>
                                            </div>
                                        </div>
                                        {renderDetail(
                                            "Insurance Price",
                                            settings?.insuranceValue,
                                            settings?.insuranceType === "percentage" ? "" : "$",
                                            settings?.insuranceType === "percentage" ? "%" : "",
                                            "fa-money-bill-wave",
                                            "col-sm-6 col-xl-3"
                                        )}
                                    </>
                                )}

                                {(() => {
                                    const getOrdinal = (n) => {
                                        const s = ['th','st','nd','rd'];
                                        const v = n % 100;
                                        return n + (s[(v-20)%10] || s[v] || s[0]);
                                    };
                                    const formatScheduleLabel = (type, weeklyDay, splitDay, monthlyDay) => {
                                        if (type === 'weekly') {
                                            const d = weeklyDay || 'monday';
                                            return `Weekly (Every ${d.charAt(0).toUpperCase() + d.slice(1)})`;
                                        }
                                        if (type === 'monthly') {
                                            return `Monthly (${getOrdinal(monthlyDay || 1)} of every month)`;
                                        }
                                        const split = splitDay || 15;
                                        return `Semi-Monthly (${getOrdinal(1)}–${getOrdinal(split)} & ${getOrdinal(split + 1)}–End)`;
                                    };

                                    const activeLabel = formatScheduleLabel(
                                        settings?.payoutCycleType,
                                        settings?.payoutWeeklyDay,
                                        settings?.payoutCycleSplitDay,
                                        settings?.payoutMonthlyDay
                                    );

                                    const hasUpcoming = !!settings?.payoutSettingsChangeEffectiveDate;
                                    const upcomingLabel = hasUpcoming
                                        ? formatScheduleLabel(
                                            settings?.nextPayoutCycleType ?? settings?.payoutCycleType,
                                            settings?.nextPayoutWeeklyDay ?? settings?.payoutWeeklyDay,
                                            settings?.nextPayoutCycleSplitDay ?? settings?.payoutCycleSplitDay,
                                            settings?.nextPayoutMonthlyDay ?? settings?.payoutMonthlyDay
                                        )
                                        : "No changes scheduled";

                                    return renderSection(
                                        "Driver Payout Schedule",
                                        "Informational payout cycle shown to drivers on wallet screen",
                                        "payout",
                                        <>
                                            <div className="col-12 col-md-6 col-xl-4">
                                                <div className="settings-stat-card">
                                                    <div className="settings-stat-card__icon">
                                                        <i className="fas fa-history" />
                                                    </div>
                                                    <span className="settings-stat-card__label">Active Schedule</span>
                                                    <span className="settings-stat-card__value mt-2" style={{ fontSize: "1.05rem" }}>
                                                        {activeLabel}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6 col-xl-4">
                                                <div className="settings-stat-card">
                                                    <div className="settings-stat-card__icon">
                                                        <i className="fas fa-clock" />
                                                    </div>
                                                    <span className="settings-stat-card__label">Upcoming (Next Month)</span>
                                                    <span className="settings-stat-card__value mt-2" style={{ fontSize: "1.05rem" }}>
                                                        {upcomingLabel}
                                                    </span>
                                                </div>
                                            </div>

                                            {hasUpcoming && (
                                                <div className="col-12 col-xl-4">
                                                    <div className="settings-stat-card">
                                                        <div className="settings-stat-card__icon">
                                                            <i className="fas fa-calendar-check" />
                                                        </div>
                                                        <span className="settings-stat-card__label">Effective Date</span>
                                                        <span className="settings-stat-card__value mt-2" style={{ fontSize: "1.05rem", color: "#F57C00" }}>
                                                            {new Date(settings.payoutSettingsChangeEffectiveDate).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    );
                                })()}


                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
